import React from 'react';

import { getAuthErrorTitle, getAuthErrorText } from './authErrorCodes';

const AuthErrorAlert = ({ isAuthLoading = false, error = {} }) => {
    const title = getAuthErrorTitle(error);
    const text = getAuthErrorText(error);

    return (
        <div className='error-alert-box'>
            {isAuthLoading
                ? ''
                : <div className='error-alert'>
                    {/* <div className='error-alert-title'>{title}</div> */}
                    <div className='error-alert-icon'>
                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" stroke="#ff7a7a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" x2="12" y1="8" y2="12"></line><line x1="12" x2="12.01" y1="16" y2="16"></line></svg>
                    </div>
                    <div className='error-alert-text'>{text}</div>
                </div>
            }
        </div>
    )
};

export default AuthErrorAlert;